<template>
  <div class="scanner">
    <div class="scanner__inner">
      <div class="scanner__camera-wrapper">
      <qrcode-stream v-if="!disabled"
          :class="['scanner__camera', {mirror: camera.type === 'front' || (camera.type === 'rear' && camera.forceType)}]"
          @init="init" @decode="decode" :torch="camera.flashlight.enabled"
          :camera="camera.forceType||camera.type"/>
      </div>

      <div class="scanner__controls" v-if="camera.ready">
        <button @click="toggleFlashlight" :class="[{on: camera.flashlight.enabled}]" v-if="camera.flashlight.available">
          <svg viewBox="0 0 257 512">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M22.3 1.66239C15.126 4.15539 9.56799 8.23739 5.98599 13.6454C0.901992 21.3214 0 26.1944 0 45.9924V63.8104H128.075H256.15L255.825 44.0604C255.514 25.1854 255.384 24.0624 252.88 18.7244C249.55 11.6234 244.187 6.26039 237.086 2.93039L231.5 0.310393L129.5 0.0833927C33.39 -0.130607 27.2 -0.0396073 22.3 1.66239ZM1.408 103.56C2.276 113.39 6.38299 131.933 9.56599 140.39C16.229 158.09 22.496 167.287 39.378 184.134C49.717 194.451 53.365 198.829 56.194 204.31C64.105 219.637 63.428 206.57 63.994 354.81L64.5 487.31L67.12 492.896C70.45 499.997 75.813 505.36 82.914 508.69L88.5 511.31H128H167.5L173.086 508.69C180.187 505.36 185.55 499.997 188.88 492.896L191.5 487.31L192 351.81L192.5 216.31L194.724 209.81C199.277 196.498 204.128 190.115 224.362 170.81C232.76 162.798 237.896 155.951 242.742 146.31C248.474 134.905 253.293 117.267 254.642 102.752L255.287 95.8104H128.006H0.723999L1.408 103.56ZM141.226 227.056C148.163 230.232 153.556 235.632 156.874 242.724C162.27 254.259 159.585 269.159 150.467 278.277C138.308 290.435 117.692 290.435 105.533 278.277C97.738 270.482 94.371 257.924 97.339 247.715C102.977 228.321 123.198 218.802 141.226 227.056Z"/>
          </svg>
        </button>
        <div v-else/>
        <button @click="toggleCamera" v-if="!camera.forceType">
          <svg viewBox="0 0 535 402">
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M340.444 22.5251C347.949 26.5401 350.492 29.6361 363.885 51.0661C380.374 77.4511 382.358 79.9541 389.589 83.5051L395.328 86.3231L445.328 86.8231C494.841 87.3181 495.369 87.3451 499.551 89.5801C505.284 92.6431 510.647 98.2031 513.205 103.734L515.328 108.323V233.823V359.323L512.745 364.829C509.529 371.684 504.856 376.435 498.349 379.465L493.328 381.803L268.116 381.813C45.6458 381.823 42.8388 381.799 37.6158 379.831C28.1188 376.255 21.6328 368.171 19.8298 357.664C19.0758 353.266 18.8318 314.241 19.0348 230.323L19.3278 109.323L21.9108 103.817C24.9048 97.4351 29.3408 92.6641 35.1938 89.5341C39.2558 87.3611 40.1859 87.3141 88.8279 86.7781C143.595 86.1751 143.63 86.1711 151.318 79.5121C153.385 77.7211 161.649 65.8341 170.163 52.4051C179.574 37.5621 186.704 27.3841 188.955 25.5791C189.132 25.4368 189.304 25.2982 189.472 25.163C190.329 24.4717 191.074 23.8707 191.871 23.3486C197.182 19.8692 204.789 19.8942 263.086 20.0859C264.79 20.0915 266.537 20.0973 268.328 20.1031C336.292 20.3231 336.33 20.3241 340.444 22.5251ZM219.617 108.341C229.849 103.28 242.011 99.2971 253.265 97.3221C263.603 95.5081 286.537 96.0401 296.828 98.3331C327.795 105.233 353.83 123.042 371.409 149.349C381.377 164.266 389.086 185.743 390.507 202.558L391.121 209.823H407.975C417.244 209.823 424.828 210.058 424.828 210.346C424.828 210.915 381.685 265.134 378.8 268.191C377.098 269.994 376.225 269.044 353.433 240.569C340.45 224.35 329.828 210.797 329.828 210.452C329.828 210.106 337.172 209.823 346.147 209.823H362.466L361.602 202.586C359.569 185.559 350.745 167.297 337.96 153.655C316.308 130.551 284.163 120.343 253.192 126.735C240.055 129.446 223.155 137.734 214.549 145.685L211.77 148.253L201.591 138.074L191.412 127.895L193.783 125.371C197.602 121.306 210.215 112.991 219.617 108.341ZM120.029 221.719C120.223 221.138 130.719 207.673 143.355 191.796C155.99 175.92 166.667 163.019 167.082 163.128C167.497 163.237 178.454 176.6 191.432 192.824L215.029 222.323L198.458 222.597L181.888 222.871L182.436 226.097C185.283 242.847 188.732 252.356 195.998 263.486C212.084 288.128 237.903 303.419 266.918 305.487C286.878 306.91 309.633 300.153 325.161 288.19C328.368 285.719 331.521 283.494 332.166 283.247C332.811 282.999 337.828 287.302 343.313 292.808L353.287 302.82L349.368 306.071C332.848 319.775 313.593 328.733 291.685 332.908C282.226 334.71 259.939 334.495 249.757 332.503C197.735 322.324 158.778 279.117 153.572 225.823L153.328 223.323L136.503 223.048C125.254 222.865 119.794 222.424 120.029 221.719Z"/>
            <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M200.328 0.864059C193.566 1.75106 185.67 4.61406 180.087 8.20306C173.075 12.7111 167.091 20.2751 154.278 40.8231C147.248 52.0981 140.361 62.5601 138.975 64.0731L136.454 66.8231L90.8909 66.8401C41.3539 66.8591 37.2429 67.2141 26.1649 72.4311C14.0329 78.1441 3.33785 92.2861 0.81085 105.957C0.13185 109.628 -0.124151 154.31 0.0558487 237.421L0.327848 363.323L2.59885 369.323C9.03985 386.341 23.4618 398.334 40.4378 400.787C49.8978 402.155 483.762 402.15 493.328 400.783C513.327 397.923 530.156 382.187 533.807 362.932C535.282 355.154 535.203 112.719 533.723 105.622C530.929 92.2251 520.498 78.2371 508.931 72.3751C498.809 67.2461 494.313 66.8591 444.594 66.8401L398.86 66.8231L395.934 64.0731C394.325 62.5601 387.25 52.0981 380.212 40.8231C373.068 29.3781 364.994 17.7661 361.933 14.5341C354.819 7.02406 345.209 2.17006 334.828 0.84306C325.934 -0.29294 209.013 -0.275941 200.328 0.864059ZM340.444 22.5251C347.949 26.5401 350.492 29.6361 363.885 51.0661C380.374 77.4511 382.358 79.9541 389.589 83.5051L395.328 86.3231L445.328 86.8231C494.841 87.3181 495.369 87.3451 499.551 89.5801C505.284 92.6431 510.647 98.2031 513.205 103.734L515.328 108.323V233.823V359.323L512.745 364.829C509.529 371.684 504.856 376.435 498.349 379.465L493.328 381.803L268.116 381.813C45.6458 381.823 42.8388 381.799 37.6158 379.831C28.1188 376.255 21.6328 368.171 19.8298 357.664C19.0758 353.266 18.8318 314.241 19.0348 230.323L19.3278 109.323L21.9108 103.817C24.9048 97.4351 29.3408 92.6641 35.1938 89.5341C39.2558 87.3611 40.1859 87.3141 88.8279 86.7781C143.595 86.1751 143.63 86.1711 151.318 79.5121C153.385 77.7211 161.649 65.8341 170.163 52.4051C179.574 37.5621 186.704 27.3841 188.955 25.5791C189.132 25.4368 189.304 25.2982 189.472 25.163C190.329 24.4717 191.074 23.8707 191.871 23.3486C197.182 19.8692 204.789 19.8942 263.086 20.0859C264.79 20.0915 266.537 20.0973 268.328 20.1031C336.292 20.3231 336.33 20.3241 340.444 22.5251Z"/>
          </svg>
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import {QrcodeStream} from 'vue-qrcode-reader';

export default {
  name: "Camera",
  components: {QrcodeStream},
  props: {
    disabled: Boolean
  },
  data() {
    return {
      result: null,
      camera: {
        ready: false,
        type: 'rear',
        forceType: null,
        flashlight: {
          available: false,
          enabled: false
        }
      }
    }
  },
  methods: {
    async init(promise) {
      try {
        const {capabilities} = await promise
        console.log(capabilities);
        this.camera.ready = true;
        if (capabilities.torch) {
          this.camera.flashlight.available = true
        }
      } catch (error) {
        console.log(error);
        if (error.name === 'OverconstrainedError') {
          // this.camera.forceType = this.camera.type === 'rear' ? 'front' : 'rear';
          this.camera.forceType = 'auto';
        } else {
          this.$emit('init', {error})
        }
      }
    },
    decode(result) {
      if (result) {
        this.result = result;
        this.$emit('detect', result)
      }
    },
    toggleFlashlight() {
      if (this.camera.ready && this.camera.flashlight.available) {
        this.camera.ready = false;
        this.camera.flashlight.enabled = !this.camera.flashlight.enabled
      }
    },
    toggleCamera() {
      if (this.camera.ready) {
        this.camera.ready = false;
        this.camera.type = this.camera.type === 'rear' ? 'front' : 'rear'
        this.camera.flashlight.enabled = false
        this.camera.flashlight.available = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.scanner {
  margin: auto auto 2rem;

  &__inner {
    position: relative;
  }

  &__camera {
    background: linear-gradient(to bottom right, #f3f2f2, #ECECEC);
    height: 100vw !important;
    max-width: 270px;
    max-height: 270px;
    overflow: hidden;
    border-radius: 15px;
    position: relative;
    margin: auto;

    @media (max-width: 340px) {
      max-height: 250px;
      max-width: 250px;
    }

    /deep/ video {
      max-width: 800px;
      position: absolute;
      margin: auto;
      left: -50vw;
      right: -50vw;
    }

    &.mirror {
      transform: scaleX(-1);
    }

    &-wrapper {
      background: linear-gradient(to bottom right, #f3f2f2, #ECECEC);
      height: 100vw !important;
      max-width: 270px;
      max-height: 270px;
      border-radius: 15px;
      margin: auto;

      @media (max-width: 340px) {
        max-height: 250px;
        max-width: 250px;
      }
    }
  }

  .qrcode-stream-wrapper {
    width: 100vw;
  }

  &__controls {
    display: flex;
    justify-content: space-between;
    padding: 15px;
    width: 100vw;
    max-width: 270px;
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
    bottom: 0;

    @media (max-width: 340px) {
      max-width: 250px;
    }

    button {
      border: 0;
      padding: 0;
      width: 30px;
      height: 30px;
      border-radius: 50%;
      background-color: rgba(0, 0, 0, 0.3);
      backdrop-filter: blur(3px);
      margin: 0;

      svg {
        width: 16px;
        height: 16px;
        display: block;
        margin: auto;
        fill: white;
      }

      &.on {
        background-color: rgba(255, 255, 255, 0.4);

        svg {
          fill: rgba(255, 255, 255, 0.8);
        }
      }
    }
  }

  &__result {
    display: block;
    font-weight: 600;
    color: var(--text);
    opacity: 0.8;
    margin: 10px 0;
    word-break: break-all;
    font-size: .8rem;
  }

  a&__result {
    text-decoration: underline;
  }
}
</style>
